module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mall-page",
    style: (_vm.bannerFlag ? 'margin-top: 45px;' : '')
  }, [_c('div', {
    staticClass: "container w"
  }, [_c('div', {
    staticClass: "nav-inner"
  }, [_c('div', {
    staticClass: "nav-tabs"
  }, _vm._l((_vm.category), function(val, i) {
    return _c('a', {
      key: i,
      class: {
        active: _vm.sortType === i
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.clickSort(i, val)
        }
      }
    }, [_vm._v(_vm._s(val))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "nav-search"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "搜索商品",
      "prefix-icon": "el-icon-search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loadMallGoods.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = $$v
      },
      expression: "searchKey"
    }
  }), _vm._v(" "), _c('y-button', {
    attrs: {
      "text": "搜索",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": _vm.loadMallGoods
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "55vh"
    },
    attrs: {
      "element-loading-text": "加载中...",
      "element-loading-background": "rgba(255,255,255,0.8)"
    }
  }, [(_vm.goodsList.length > 0) ? _c('div', {
    staticClass: "goods-item"
  }, [_c('div', {
    staticClass: "goods-box"
  }, _vm._l((_vm.goodsList), function(item, i) {
    return _c('mall-goods', {
      key: i,
      attrs: {
        "msg": item
      },
      on: {
        "openDialog": _vm.openDialog
      }
    })
  }), 1), _vm._v(" "), (!_vm.error) ? _c('div', {
    staticClass: "load-more-tip"
  }, [(_vm.loadingMore) ? _c('span', [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 正在加载更多商品...")]) : (_vm.noMore) ? _c('span', [_vm._v("— 已加载全部商品 —")]) : _c('span', [_vm._v("向下滚动加载更多")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.noGoods) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('y-shelf', {
    attrs: {
      "title": _vm.recommendPanel.name
    }
  }, [_c('div', {
    staticClass: "recommend",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.recommendPanel.panelContents), function(item, i) {
    return _c('mall-goods', {
      key: i,
      attrs: {
        "msg": item
      }
    })
  }), 1)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('y-shelf', {
    attrs: {
      "title": _vm.recommendPanel.name
    }
  }, [_c('div', {
    staticClass: "recommend",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.recommendPanel.panelContents), function(item, i) {
    return _c('mall-goods', {
      key: i,
      attrs: {
        "msg": item
      }
    })
  }), 1)])], 1)]) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogFlag,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFlag = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/qr/qrcode.jpg"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("扫码进入"), _c('span', {
    staticStyle: {
      "color": "#1890ff"
    }
  }, [_vm._v("医小智Mall")]), _vm._v("小程序下单")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/no-search.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("抱歉！暂时还没有商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/error.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("抱歉！出错了...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b445736a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Mall/index.vue
// module id = 686
// module chunks = 0